import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import '../styles/AdminGate.css'

function AdminGate() {
  const [gatePassword, setGatePassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!gatePassword.trim()) {
      setError("Please enter the admin password");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const API_URL = process.env.REACT_APP_API_URL;

      const res = await axios.post(
        `${API_URL}/api/admin/verify-gate`,
        { gatePassword },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      if (res.data.message === "Access granted") {
        localStorage.setItem("adminGate", "passed");
        navigate("/panel");
      }
    } catch (err) {
      setError("Wrong admin password");
    }

    setLoading(false);
  };

  return (
    <div className="admin-section-wrapper">
      <div className="admin-section-box">
        <h2>Admin Security Check</h2>

        <div className="admin-section-input-container">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Enter admin password"
            value={gatePassword}
            onChange={(e) => setGatePassword(e.target.value)}
            className="admin-section-input"
          />
          <span
              onClick={() => setShowPassword(!showPassword)}
              className="eye-icon"
          >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        {error && <p className="error">{error}</p>}

        <button onClick={handleSubmit} className="admin-section-submit-button">
          {loading ? "Checking..." : "Enter"}
        </button>
      </div>
    </div>
  );
}
export default AdminGate;
